// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"31391784","453":"f78aff0b"}[chunkId] + ".chunk.js";
};